import React from 'react';

import classNames from 'classnames';
import LockIcon from 'icons/ic-lock.svg';
import RedLockIcon from 'icons/ic-red-lock.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import TextField from 'components/application/TextField';

export default function PasswordField({
  children,
  errorMessage,
  instructionMessage,
  onInputKeyDown,
  onPasswordInputChange,
  passwordInput,
  validationError,
}) {
  const { t: i18nTCommon } = useTranslation('common');

  const Icon = validationError ? RedLockIcon : LockIcon;

  return (
    <>
      <div
        className={classNames(
          'download-container__sub-text tw-mt-5',
          validationError ? 'tw-text-red-600' : 'tw-text-grey-600',
        )}
      >
        <Icon
          className={classNames(
            'download-container__svg tw-mb-0.75 tw-mr-2',
            validationError ?
              '[&_path]:tw-fill-red-600'
            : '[&_path]:tw-fill-grey-600',
          )}
          height={18}
          width={16}
        />
        {validationError ? errorMessage : instructionMessage}
      </div>
      <div className='download-container__input tw-mt-6'>
        <TextField
          fieldError={validationError}
          label={i18nTCommon('shared.password')}
          name='password'
          onChange={onPasswordInputChange}
          onKeyDown={onInputKeyDown}
          type='password'
          value={passwordInput.password}
        />
      </div>
      {children}
    </>
  );
}

PasswordField.propsTypes = {
  children: PropTypes.node.isRequired,
  errorMessage: PropTypes.string.isRequired,
  instructionMessage: PropTypes.string.isRequired,
  onInputKeyDown: PropTypes.func.isRequired,
  onPasswordInputChange: PropTypes.func.isRequired,
  passwordInput: PropTypes.object.isRequired,
  validationError: PropTypes.bool.isRequired,
};
